<template>
 <main class="d-flex align-items-center min-vh-100 py-3 py-md-0">
      <div class="container">
        <div class="card login-card">

  <v-app>
    <div class="card-body" style="position:relative">
      <v-container>
        <v-row>
          <v-layout align-center>
            <v-flex xs12>
              <a
                href="https://wa.me/221781528375?text=Bonjour Ojay j'aimerai utiliser votre service de livraison"
              >
                <img src="../assets/ads/ojay.gif" width="100%" alt="" />
              </a>
            </v-flex>
          </v-layout>
        </v-row>
      </v-container>
      <v-alert
        v-if="show_message_error"
        style="margin-top:50px"
        dense
        outlined
        type="error"
        text
        color="red"
      >
        {{ error_message_order }}
      </v-alert>
      <kiosque-shop
        v-else
        :colorinfos="colorCartButton"
        :articles="articles" :shopname="titleshop" :shopdescription="descriptionshop"
        :idshop="idshop" :redirect="redirect"
        :businesslogo="Logobusiness" :end_message="message_end" :text_snackbardelivery="message_start"
      ></kiosque-shop>
    </div>
  </v-app>
  </div>
      </div>
    </main>
</template>

<script>
import Kiosque from "./pieces/kiosque.vue";
import Kyc from "./pieces/kyc.vue";

var moment = require("moment");
moment.locale("fr");

export default {
  title: "",
  components: {
    "kiosque-shop": Kiosque,
    "know-your-customer": Kyc
  },
  data() {
    return {
      articles: [],
      errorbi: null,
      Logobusiness: '',
      idshop: null,
      redirect: "https://kiosk.ojay.delivery/ojaybackend",
      categories: false,
      show_message_error: false,
      error_message_order:
        "Ayyy ! Nous rencontrons un problème technique, Impossible de commander pour le moment. Vous pourrez commander dans quelques minutes",
      show_kiosk: false,
      kiosk_subdomain: null,
      titleshop:'',
      descriptionshop: '',
      message_end: '',
      message_start: '',
      colorCartButton:{}
    };
  },
  mounted() {
    console.log("monted zerr getCategories()");
    this.getInfoShopFromSubdomain();
    //this.getCategories();
  },
  computed: {
    article_details: function() {}
  },
  watch: {
    article_details: function(newval, oldval) {
      if (_.isArray(newval)) {
        console.log();
        this.show_kiosk = true;
      }
    }
  },
  methods: {
     getTitle (vm) {
  const { title } = vm.$options
  if (title) {
    return typeof title === 'function'
      ? title.call(vm)
      : title
  }
},
    extractSubdomain() {
      console.log("getInfoShopFromSubdomain");
      let subdomain = window.location.host;
      if (subdomain.includes("localhost")) {
        console.log("on est dans le localhost ==>");
        subdomain = "nandal.ojay.delivery";
      }
      subdomain = _.replace(subdomain, "www.", "");
      const parts = subdomain.split(".");
      console.log('EXTRACCCTIONNNNNN =====>',parts);
      return parts[0];
    },
    getInfoShopFromSubdomain() {
      this.kiosk_subdomain = this.extractSubdomain();
      let Oldthis = this;

      console.log("subdomain => this.kiosk_subdomain", this.kiosk_subdomain);

      let pathzer =
        this.redirect + "/get/datas/combineshop/" + this.kiosk_subdomain;
      console.log("path_zer  =>", pathzer);

      this.$http.get(pathzer).then(
        function(response) {
          console.log(
            "postReservation response.data.shop",
            response.data.shop
          );
          if (response.data.shop) {
            Oldthis.articles = response.data.shop.articles;
            Oldthis.Logobusiness =
            Oldthis.redirect +'/public'+response.data.shop.Logobusiness;
            Oldthis.idshop = response.data.shop.idshop;
            Oldthis.message_end = response.data.shop.message_end;
            Oldthis.message_start = response.data.shop.message_start
            Oldthis.titleshop  = response.data.shop.titleshop
            Oldthis.descriptionshop  = response.data.shop.descriptionshop
            document.querySelector('body').setAttribute('style', 'background:'+response.data.shop.design.backgroundColor)
            document.title = Oldthis.kiosk_subdomain + document.title
            let buttonCartColor = {buttonCartColor: "#EF323D"};
            let colorCartColor  = {textCartColor: "#fafafa"};

            if(response.data.shop.design.buttonCartColor){
                 buttonCartColor.buttonCartColor = response.data.shop.design.buttonCartColor ;
            }
            if(response.data.shop.design.textCartColor){
                  colorCartColor.textCartColor =  response.data.shop.design.textCartColor;
            }

              Oldthis.colorCartButton= {...buttonCartColor,...colorCartColor}


          }
        },
        function(error) {
          console.log("Nous avons bien une error");
          console.log("---------------------------");
          console.log(error);
        }
      );
    },
    treatementCategoriesObject(categories) {
      return this.articles.map(article => {
        var yaya = {};
        categories.forEach(category => {
          if (category._id == article.title) {
            yaya = Object.assign(article, { current_order: category.quantite });
          }
        });
        if (_.isEmpty(yaya)) {
          yaya = Object.assign(article, { current_order: 0 });
        }
        return yaya;
      });
    },
    getCategories() {
      return new Promise((resolve, reject) => {
        const Oldthis = this;
        var beginmount = moment(new Date()).format(
          "YYYY-MM-DD[T00:00:00.000Z]"
        );
        var endinmount = moment(new Date()).format(
          "YYYY-MM-DD[T23:59:59.000Z]"
        );
        var paramsbegin = { gte: beginmount, lte: endinmount };

        console.log("getCategoriessss paramsbegin ===>", paramsbegin);
        console.log(this.redirect + "/get/categories/" + this.idshop);
        //let redirection = "https://douxgup.ojay.delivery/test";
        this.$http
          .post(this.redirect + "/get/categories/" + this.idshop, {
            datelte: paramsbegin
          })
          .then(
            function(response) {
              if (response.data.categories) {
                console.log("CATEGORIES ====>", response.data.categories);
                //Oldthis.categories = response.data.categories;
                resolve(response.data.categories);
              }
              if (response.data.error) {
                this.show_message_error = true;
              }
            },
            function(error) {
              console.log("error get Categories==>", error);
              this.show_message_error = true;

              reject(error);
            }
          );
      });
    },
    pushInCart(obj) {
      let indexcart = _.findIndex(this.cart, function(o) {
        return o.id == obj.id;
      });

      //console.log('find in indexcart ---> ',indexcart);
      if (indexcart < 0) {
        //console.log('<---- isUndefined ---->');
        let article = _.find(this.articles, function(art) {
          return art.id == obj.id;
        });
        //console.log('find article in articles ----->',article);

        this.cart.push({
          id: obj.id,
          article: article,
          quantity: obj.quantity,
          total_price: article.pricing
        });
      } else {
        if (obj.quantity == 0) {
          // si la quantité est égal à 0 on le supprime de la cart
          _.remove(this.cart, function(elem) {
            return elem.id == obj.id;
          });
        } else {
          this.cart[indexcart]["quantity"] = obj.quantity;
          this.cart[indexcart]["total_price"] =
            parseInt(this.cart[indexcart]["article"]["pricing"]) *
            parseInt(obj.quantity);
          console.log(
            "this.cart[" + indexcart + "]['quantity'] == ",
            obj.quantity
          );
          console.log(
            "this.cart[" + indexcart + "]['article']['pricing'] == ",
            this.cart[indexcart]["article"]["pricing"]
          );

          console.log(
            "this.cart[" + indexcart + "]['total_price'] == ",
            this.cart[indexcart]["total_pricing"]
          );
        }
        console.log("<---- EXIST ---->");
      }
      console.log("THE CART ENDD ------> ", this.cart);
    },
    sommeofquantities(obj) {
      /*
           console.log('--------------sommeofquantities-------------');
           console.log('la quantité importé ----obj---->',obj);
           console.log('--------------end----sommeofquantities-------------');
           */
      this.nb_items += parseInt(obj.unit);

      this.pushInCart(obj);
      console.log("-----------end-------------");
    }
  }
};
</script>
<style>
.branding {
  position: relative;
}
.nb-article {
  font-weight: bold;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/ModalHome.vue